import account from './account-reducer'
import { combineReducers } from 'redux'
import form from './form-reducer'
import subscription from './subscription-reducer'

export default combineReducers({
  account, form, subscription
})
